
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PolicyDocuments from '@/services/PolicyDocuments';

import Alert from '@/components/Global/Alert.vue';
import AccordionList from '@/components/Global/Accordion/AccordionList.vue';
import { mapGetters } from 'vuex';
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import Loading from '@/components/Global/Loading.vue';
import ProgressBar from 'vue-simple-progress';
import {
	AsyncNotifications,
	NotifyListener,
	NotifyEvent,
	notify,
} from '@/services/AsyncNotifications';

@Component({
	components: {
		Alert,
		AccordionList,
		ProgressBar,
		SelectField,
		TextField,
		Loading,
	},
})
export default class InvoicesList extends Vue {
	@Prop()
	private invoices: any;
	@Prop() private reportType: string;
	private paginate: string[];
	private fetching: boolean;
	private increasingPct: any;
	private updatedInvoices: any;
	private searchText: string;
	private filterSearchType: string;
	private sortType: string;
	private fromYear: string;
	private toYear: string;
	constructor() {
		super();
		this.paginate = ['updatedInvoices'];
		this.fetching = false;
		this.increasingPct = 0;
		this.updatedInvoices = [];
		this.searchText = '';
		this.filterSearchType = 'Name';
		this.sortType = 'Number';
		this.fromYear = '';
		this.toYear = '';
	}

	private titleCase(str) {
		if (str) {
			return str
				.toLowerCase()
				.split(' ')
				.map(word => {
					return word.charAt(0).toUpperCase() + word.slice(1);
				})
				.join(' ');
		}
		return '';
	}

	@Watch('fromYear')
	@Watch('toYear')
	private watchYears() {
		let filteredInvoices = null;
		const that = this;
		if (
			this.fromYear &&
			this.toYear &&
			this.fromYear.length === 4 &&
			this.toYear.length === 4
		) {
			filteredInvoices = this.invoices
				.map(invoice => {
					if (invoice.year >= that.fromYear && invoice.year < that.toYear) {
						return invoice;
					}
				})
				.filter(invoice => {
					if (invoice !== undefined) {
						return invoice;
					}
				});
			this.invoices = filteredInvoices;
			this.updatedInvoices = filteredInvoices;
		}
	}

	private async created() {
		this.updatedInvoices = this.invoices;
		console.log('invoices list', this.invoices);
	}
	private search() {
		this.updatedInvoices = this.invoices;
		// this.searchText = this.searchText.toLowerCase();
		const that = this;
		if (this.searchText) {
			const regex = new RegExp(this.searchText, 'g');
			const filteredInvoices = this.invoices
				.map(invoice => {
					if (
						that.filterSearchType === 'Name' &&
						invoice.policyHolder !== undefined &&
						invoice.policyHolder.match(regex)
					) {
						return invoice;
					} else if (
						that.filterSearchType === 'Number' &&
						invoice.policyNum !== undefined &&
						invoice.policyNum.match(regex)
					) {
						return invoice;
					}
				})
				.filter(invoice => {
					if (invoice !== undefined) {
						return invoice;
					}
				});

			this.updatedInvoices = filteredInvoices;
		} else {
			this.updatedInvoices = this.invoices;
		}
	}
	private changeSearchType($event) {
		this.filterSearchType = $event.target.value;
	}
	private changeSortType($event) {
		this.sortType = $event.target.value;

		if (this.sortType === 'Number') {
			this.updatedInvoices = this.updatedInvoices.sort((a, b) =>
				a.policyNum.localeCompare(b.policyNum),
			);
		}
		if (this.sortType === 'NameAZ') {
			this.updatedInvoices = this.updatedInvoices.sort((a, b) =>
				a.policyHolder.localeCompare(b.policyHolder),
			);
		}
		if (this.sortType === 'NameZA') {
			this.updatedInvoices = this.updatedInvoices.sort((a, b) =>
				a.policyHolder.localeCompare(b.policyHolder),
			);
			this.updatedInvoices = this.updatedInvoices.reverse((a, b) =>
				a.policyHolder.localeCompare(b.policyHolder),
			);
		}
	}
	private async mounted() {
		setInterval(() => {
			if (!this.fetching) {
				return;
			}
			this.increasingPct = Math.min(this.increasingPct + 5, 100);
			if (this.increasingPct === 100) {
				this.fetching = false;
			}
		}, 2000);
	}
	private async downloadInvoice(invoice) {
		this.fetching = true;
		const data = await PolicyDocuments.requestInvoice(
			invoice.policyNum,
			invoice.docId,
			invoice.year,
		);

		if (data.fetching) {
			const listener: NotifyListener = (event: NotifyEvent): void => {
				if (event.message.type === 'docstatus') {
					if (event.message.ready) {
						window.location.assign(event.message.fname);
					}
					this.fetching = false;
					AsyncNotifications.singleton.removeEventListener(notify, listener);
				}
			};
			AsyncNotifications.singleton.addEventListener(notify, listener);
		} else {
			window.location = data.s3url;
			this.fetching = false;
		}
	}
}
